import React from 'react'
import '../pages/css/Home.css';
import '../pages/css/CustomSoftwareDevelopment.css';
import BlogSection from './components/BlogSection';
import OurPartner from './components/OurPartner';

function BlogPage() {
  return (
    <>
    <BlogSection />
     <OurPartner />
    </>
  )
}

export default BlogPage